<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-upload
          ref="uploadRef"
          class="upload-demo"
          :action="uploadUrl"
          :headers="uploadHeader"
          :data="form"
          :multiple="false"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :limit="1"
          :on-exceed="onExceed"
          :on-success="onSuccessUpload"
          :on-error="onErrorUpload"
      >
        <template #trigger>
          <el-button style="width: 100%" type="primary">
            Tashkilotlarni Excel orqali kiritish
          </el-button>
        </template>
      </el-upload>

      <el-button type="success" @click="downloadExcel"
      ><img
          src="@/assets/images/icons/download.svg"
          alt=""
          style="margin-right: 5px"
      />
        Mavjud tashkilotlar listini yuklab olish
      </el-button>

      <el-select
          v-model="selectedRegion"
          placeholder="Viloyatlar"
          @change="getDistricts"
          :loading="regionsLoading"
      >
        <el-option value="" label="Barchasi"/>
        <el-option
            v-for="region in regions"
            :key="region.id"
            :value="region.id"
            :label="region.title"
        />
      </el-select>
      <el-select
          placeholder="Tuman/Shaxar"
          v-model="district_id"
          :loading="loading"
          @change="getOrganizationsList"
      >
        <el-option value="" label="Barchasi"/>
        <el-option
            v-for="district in districts"
            :key="district.id"
            :value="district.id"
            :label="district.title"
        />
      </el-select>

      <el-select
          placeholder="Tashkilot turini tanlang"
          v-model="selectedType"
          @change="getOrganizationsList"
      >
        <el-option value="" label="Barchasi"/>
        <el-option
            v-for="typs in types"
            :key="typs.value"
            :value="typs.value"
            :label="typs.label"
        />
      </el-select>

      <el-button
          class="custom-btn"
          @click="() => this.$router.push({ name: 'OrganizationAdd' })"
          type="primary"
      >Qo'shish
      </el-button
      >
    </div>

    <el-table :data="organizations" border height="calc(100vh - 210px)">
      <el-table-column type="index"/>
      <el-table-column prop="title" label="Sarlavha" min-width="150"/>
      <el-table-column
          prop="organization_type"
          label="Tashkilot turi"
          min-width="150"
      />
      <el-table-column
          prop="org_code"
          label="Tashkilot kodi"
          min-width="50"
      />

      <el-table-column prop="inn" label="Inn" min-width="150"/>
      <el-table-column width="200" label="Tahrirlash/O'chirish">
        <template #default="scope">
          <el-button
              size="small"
              @click="onEditOrganization(scope.row.id)"
              type="primary"
          >Tahrirlash
          </el-button
          >
          <el-button
              size="small"
              @click="onDeleteOrganization(scope.row.id)"
              type="danger"
          >O'chirish
          </el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div>Tashkilotlar soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import {ElMessage, ElMessageBox, ElNotification} from "element-plus";

export default {
  name: "OrganizationsView",
  data() {
    return {
      uploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v1/organizations/sync`,
      uploadHeader: {Authorization: `${this.$store.state.accessToken}`},
      loading: false,
      regionsLoading: false,
      districtsLoading: false,
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      regions: [],
      selectedRegion: 2,
      district_id: 23,
      types: [
        {value: "KINDERGARDEN", label: "Bog‘cha"},
        {value: "SCHOOL", label: "Maktab"},
        {value: "HEALTHCARE", label: "Sog‘liqni saqlash"},
        {value: "HIGHERSCHOOL", label: "Oliy ta'lim"},
        {value: "MUSIC", label: "Musiqa"},
        {value: "SPORT", label: "Sport"},
        {value: "CULTURE", label: "Aholi dam olish maskanlari"},
        {value: "OTHEREDUCATIONS", label: "Boshqa"},
      ],
      selectedType: "SCHOOL",
      districts: [],
      organizations: [],
    };
  },
  methods: {
    getDistricts() {
      this.$http
          .get(`api/v1/districts`, {
            params: {
              region_id: this.selectedRegion,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
            this.getOrganizationsList();
          })
          .catch((err) => {
            console.error("quarters fetch error", err);
          });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
            this.getOrganizationsList();
          })
          .catch(() => {
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    onSuccessUpload() {
      console.log("success upload");
      this.loading = false;
      ElNotification.success({
        message: "Amaliyot muvaffaqiyatli bajarildi!",
      });
      this.getOrganizationsList();
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification.error({
        message:
            JSON.parse(error?.message)?.message ||
            "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    onExceed(files) {
      console.log("exceeds", files);
      // this.form.file[0] = files[0]
    },
    downloadExcel() {
      this.loading = true;
      this.$http
          .get(`api/v1/organizations/excel`, {
            responseType: "blob",
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onEditOrganization(id) {
      this.$router.push({name: "OrganizationAdd", query: {id}});
    },
    onDeleteOrganization(id) {
      ElMessageBox.confirm("Tashkilotni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
          .then(() => {
            this.loading = true;
            this.$http
                .delete(`/api/v1/organizations/${id}`)
                .then(() => {
                  ElMessage({
                    type: "success",
                    message: "Tashkilot o'chirildi",
                  });
                  this.getOrganizationsList();
                })
                .catch(() => {
                  ElNotification({
                    type: "error",
                    title: "Xatolik",
                    message: "Iltimos, qayta urinib ko'ring",
                  });
                })
                .finally(() => {
                  this.loading = false;
                });
          })
          .catch(() => {
            ElMessage({
              type: "info",
              message: "O'chirish bekor qilindi",
            });
          });
    },

    getOrganizationsList() {
      this.loading = true;
      this.$http
          .get("/api/v1/organizations/pagination", {
            params: {
              limit: this.limit,
              offset: this.limit * (this.currentPage - 1),
              organization_type: this.selectedType,
              region_id: this.selectedRegion,
              district_id: this.district_id,
            },
          })
          .then(({data}) => {
            this.organizations = data.organizations;
            this.totalCount = data.count;
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.limit + 1;
    },
    handleCurrentChange() {
      this.$router.replace({
        query: {...this.$route.query, page: this.currentPage},
      });
      this.getOrganizationsList();
    },
    handleSizeChange() {
      this.$router.replace({
        query: {...this.$route.query, size: this.limit, page: 1},
      });
      this.currentPage = 1;
      this.getOrganizationsList();
    },
  },
  mounted() {
    this.getDistricts();
    this.getRegions();
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
  },
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}
</style>
